var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLessonIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0833 2.58337L5.74996 2.58337C5.19742 2.58337 4.66752 2.80287 4.27682 3.19357C3.88612 3.58427 3.66663 4.11417 3.66663 4.66671L3.66663 21.3334C3.66663 21.8859 3.88612 22.4158 4.27682 22.8065C4.66752 23.1972 5.19742 23.4167 5.74996 23.4167L18.25 23.4167C18.8025 23.4167 19.3324 23.1972 19.7231 22.8065C20.1138 22.4158 20.3333 21.8859 20.3333 21.3334L20.3333 8.83337L14.0833 2.58337Z",
    stroke: "#98BDBD",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0833 2.58334L14.0833 8.83334L20.3333 8.83334",
    stroke: "#98BDBD",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.1666 14.0416L7.83325 14.0416",
    stroke: "#98BDBD",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.1666 18.2084L7.83325 18.2084",
    stroke: "#98BDBD",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.91659 9.875L8.87492 9.875L7.83325 9.875",
    stroke: "#98BDBD",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonIc);
export default __webpack_public_path__ + "static/media/lesson_ic.e5e9adc19bf2239f74ecc89b870939d0.svg";
export { ForwardRef as ReactComponent };